'use strict';

var UserProfilePanelConfig = function UserProfilePanelConfig($stateProvider) {
  $stateProvider.state('app.user-profile', {
    url: '/workflow/user-profile',
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: require('../templates/user-profile-panel.html'),
        controller: 'UserProfilePanelController'
      },
      'mainToolbar': {
        template: require('../templates/user-profile-panel-toolbar.html'),
        controller: 'UserProfilePanelToolbarController'
      }
    }
  });
};
module.exports = UserProfilePanelConfig;
UserProfilePanelConfig.$inject = ['$stateProvider'];